import React from 'react';

const economicsData = [
  {
    id: 1,
    title: "Cleaner Income Instability",
    problem: "Independent cleaners struggle with inconsistent bookings, lack of business infrastructure, and no long-term income or retirement path beyond cleaning more hours.",
    profitTitle: "Cleaner-Membership Marketplace + Clean Talent Scout Program",
    profit: "Recurring cleaner memberships create predictable platform revenue while providing cleaners with consistent work, operational support, and pathways to earn beyond labor through referrals and talent scouting."
  },
  {
    id: 2,
    title: "Rising Cost of Technology & Operations",
    problem: "Maintaining high-quality technology, support teams, and operational infrastructure erodes margins when funded solely through service pricing.",
    profitTitle: "3% Platform Service Fee",
    profit: "A small, transparent service fee funds infrastructure, support, and platform operations without distorting customer pricing or cleaner earnings."
  },
  {
    id: 3,
    title: "Pricing Confusion & Platform Fee Friction",
    problem: "Clients dislike opaque flat-rate pricing, while cleaners resent high per-booking platform fees—especially when volume is inconsistent.",
    profitTitle: "Hourly Rate Markup Model",
    profit: "Platform-set hourly rates with a modest $5–$10/hr markup provide transparent pricing for clients and a predictable 90/10 cleaner-to-platform split, while driving higher booking frequency through competitive market rates."
  },
  {
    id: 4,
    title: "Workforce Access for B2B Operators",
    problem: "Businesses like real estate brokerages, property managers, event organizers, and cleaning companies need reliable cleaning talent on demand—but lack deployable workforce infrastructure.",
    profitTitle: "White Glove Membership (Launching Feb/Mar 2026)",
    profit: "A B2B2C membership that provides access to a white-labeled, on-demand cleaning workforce across service areas—allowing partners to scale service delivery without building their own labor operations."
  },
  {
    id: 5,
    title: "Emergency & Same-Day Demand Gaps",
    problem: "Customers occasionally require urgent, same-day cleaning, but traditional scheduling systems can't reliably support emergency demand.",
    profitTitle: "Same-Day Expedited Fee",
    profit: "Demand-based surge fees prioritize urgent requests, mobilize supply faster, and compensate the additional operational effort required—without penalizing standard bookings."
  },
  {
    id: 6,
    title: "Cleaner Supply & Equipment Friction",
    problem: "Cleaners face high friction sourcing, replacing, and financing professional supplies and equipment, while supply quality directly impacts service outcomes.",
    profitTitle: "Embedded Commerce & Equipment Financing Layer",
    profit: "An integrated supply store allows cleaners to purchase, lease, or finance equipment and consumables at wholesale-backed pricing—generating 25–50% margins on resale and higher margins on financing and leasing."
  },
  {
    id: 7,
    title: "Scale Without Economic Degradation",
    problem: "Many marketplaces sacrifice unit economics in pursuit of scale, hoping volume will eventually correct margin inefficiencies.",
    profitTitle: "Multi-Pillar Revenue Per Transaction",
    profit: "Each booking activates multiple economic layers—memberships, service fees, rate margins, B2B access, expedited fees, and commerce—allowing scale to strengthen unit economics rather than dilute them."
  }
];

const MarketplaceUnitEconomics = () => {
  return (
    <section className="py-20 px-6 md:px-12 lg:px-24 bg-gray-50/50">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-semibold text-gray-900 mb-3 text-center">
          Our Marketplace Unit Economics
        </h2>
        <p className="text-lg text-gray-600 mb-16 text-center">
          Seven structural problems. Seven embedded profit pillars.
        </p>
        
        {/* Rows */}
        <div className="space-y-6">
          {economicsData.map((item) => (
            <div 
              key={item.id}
              className="bg-white rounded-lg border border-gray-100 shadow-sm overflow-hidden"
            >
              {/* Row Header */}
              <div className="px-6 py-4 border-b border-gray-100 bg-gray-50/50">
                <div className="flex items-center gap-3">
                  <span className="flex-shrink-0 w-7 h-7 rounded-full bg-gray-200 text-gray-700 text-sm font-semibold flex items-center justify-center">
                    {item.id}
                  </span>
                  <h3 className="text-lg font-semibold text-gray-900">
                    {item.title}
                  </h3>
                </div>
              </div>

              {/* Two Column Content */}
              <div className="grid md:grid-cols-2">
                {/* Problem Column */}
                <div className="p-6 md:border-r md:border-gray-100">
                  <span className="text-xs font-semibold text-gray-400 uppercase tracking-wider block mb-3">
                    Problem
                  </span>
                  <p className="text-gray-600 leading-relaxed">
                    {item.problem}
                  </p>
                </div>

                {/* Profit Pillar Column */}
                <div className="p-6 border-t md:border-t-0 border-gray-100 bg-gray-50/30">
                  <span className="md:hidden text-xs font-semibold text-gray-400 uppercase tracking-wider block mb-2">
                    Profit Pillar
                  </span>
                  <p className="text-gray-900 font-medium leading-relaxed mb-2">
                    {item.profitTitle}
                  </p>
                  <p className="text-gray-600 leading-relaxed text-sm">
                    {item.profit}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MarketplaceUnitEconomics;
